if(!window.utils){
    window.utils = {};
}

window.utils.getUrlParams = function () {
    var url = location.search; //获取url中"?"符后的字串
    var res = {};
    if (url.indexOf("?") != -1) {
        var str = url.substr(1),
            strs = str.split("&"),
            strArr,
            key,
            val;
        for(var i = 0; i < strs.length; i ++) {
            strArr = strs[i].split("=");
            key = strArr[0];
            val= strArr[1];
            if(typeof key === 'undefined' || typeof val === 'undefined'){
                continue;
            }
            res[key] = decodeURIComponent(val);
        }
    }
    return res;
};

window.utils.toFixedNumber = function(number,compareVal){
    if(number < compareVal){
        number = String(number);
        compareVal = String(compareVal);
        let counter = compareVal.length - number.length;
        for(var i = counter;i > 0;i--){
            number = '0' + number;
        }
    }
    return number;
}


if(!window.functions){
    window.functions = {};
}
window.functions = {

    // 带天并兼容分秒的倒计时
    countDown(times,dom,type){
        var timer=null;
        timer=setInterval(function(){
            var day=0,
                hour=0,
                minute=0,
                second=0;
            if(times > 0){
                day = Math.floor(times / (60 * 60 * 24));
                hour = Math.floor(times / (60 * 60)) - (day * 24);
                minute = Math.floor(times / 60) - (day * 24 * 60) - (hour * 60);
                second = Math.floor(times) - (day * 24 * 60 * 60) - (hour * 60 * 60) - (minute * 60);
            }
            var format_date = '';
            if (type){
                if (minute <= 9) minute = '0' + minute;
                if (second <= 9) second = '0' + second;
                minute = parseInt(day*60*24) + parseInt(hour*60) + parseInt(minute);
                format_date = minute+":"+second;
            }else{
                if (day <= 9) day = '0' + day;
                if (hour <= 9) hour = '0' + hour;
                if (minute <= 9) minute = '0' + minute;
                if (second <= 9) second = '0' + second;
                format_date = day+"天"+hour+"小时"+minute+"分钟"+second+"秒";
            }

            if (format_date) {
                $(dom).html(format_date);
            }
            times--;
        },1000);
        if(times<=0){
            clearInterval(timer);
        }
        return timer;
    },
    showArticleAll : function () {
        var $this = $(this);
        $this.parent().removeClass('article-mask-active article-mask').css({
            'max-height': 'unset'
        })
    },


    initLaydate (el,format = 'yyyy-MM-dd HH:mm:ss',defaultTime = '23:59:59',fnEnd = ()=>{}){
        if(!laydate){
            throw new Error('laydate is not loaded');
        }

        var year = new Date().getFullYear() + '',
            month = window.utils.toFixedNumber((new Date().getMonth() + 1),10) + '',
            day = window.utils.toFixedNumber(new Date().getDate(),10) + '',
            separatorYear = format[format.indexOf('yyyy') + 4],
            separatorMonth = format[format.indexOf('MM') + 2],
            separatorDay = format[format.indexOf('dd') + 2].trim() || '',
            currentDay = year + separatorYear + month + separatorMonth + day + separatorDay,
            isInitValue = !!$(el).val(),
            defTimeArr = defaultTime.indexOf(':') > -1 ? defaultTime.split(':') : [],
            value = isInitValue ? $(el).val() : currentDay + ' ' + defaultTime;


        //执行一个laydate实例

        let instance = laydate.render({
            elem: el,
            format: format,
            type: 'datetime',
            value: value,
            isInitValue: isInitValue,
            done: function (val) {
                if(val === ''){
                    instance.config.value = '';
                    clearVal();
                }
            },
            ready: function () {
                instance.config.dateTime.hours = defTimeArr[0];
                instance.config.dateTime.minutes = defTimeArr[1];
                instance.config.dateTime.seconds = defTimeArr[2];
            }
        });
        setTimeout(()=>{
            if(!isInitValue){ //isInitValue 配置不生效
                clearVal();
            }
            fnEnd(el,instance);
        },150);

        function clearVal() {
            $(el).attr({
                value: ''
            }).val('');
        }

    }

};
class autoSave{
    constructor (ele,obj = {}){
        this.$ele = $(ele);
        this.ele = ele;

        this.filterField = obj.filterField || ['__hash__'];
        this.autoSave = typeof obj.autoSave != 'undefined' ? obj.autoSave : 5000;
        this.autoAssign = typeof obj.autoAssign != 'undefined' ? obj.autoAssign : true;

        this.saveId = $.trim('autoSave-' + ele);

        this.init();

        return this;
    }

    init(){
        let that = this;

        if(!localStorage.getItem(this.saveId)){
            localStorage.setItem(this.saveId,'null');
        }

        if(this.autoSave){
            this.loopSave();
        }

        if(this.autoAssign){
            this.assign();
        }

    }

    loopSave(){
        setTimeout(() =>{
            this.save();
            this.loopSave();
        },this.autoSave);
    }

    save(){
        return new Promise((resolve)=>{
            let data = this.getSerializeFormData();
            localStorage.setItem(this.saveId,JSON.stringify(data));
            resolve(data);
        });
    }

    //获取数据  返回一个数组
    getData(attr = ''){
        let data = JSON.parse(localStorage.getItem(this.saveId));
        if(attr){
            let res = [];
            data.forEach((v)=>{
                if(v.name == attr){
                    res.push(v.value);
                }
            });
            return res;
        }
        return data;
    }

    //赋值
    assign(){
        let data = this.getData();
        if(!data){
            return false;
        }

        let tempObj = {};
        for(let v of data){
            if(this.filterField.indexOf(v.name) > -1){
                continue;
            }
            if(typeof tempObj[v.name] != 'number'){
                tempObj[v.name] = 0;
            }else{
                ++tempObj[v.name];
            }
            this.$ele.find(`*[name="${v.name}"]`).eq(tempObj[v.name]).val(v.value);
        }
    }

    getSerializeFormData() {
        return this.$ele.serializeArray();
    }
}

var MenuIcon = function (node,options){
	this.node = $(node);
	this.options = options;
	var _this = this;
	this._li = this.node.find("li");
	this.init();
	this.node.find('li .item').click(function(){
		_this.nodeClick($(this).parent('li'));
	});
}

MenuIcon.prototype.init = function(){
	this.node.find('.item-content').hide();
	this.node.find('.item-content').each(function(){
		if($(this).data('show') == 1) {
			$(this).show();
		}
	});
	this.node.find('.item .iconfont:last-child').addClass(this.options.hide);
}

MenuIcon.prototype.nodeClick = function(_this){
	var itemContent = _this.find(".item-content"),
		toggles = itemContent.siblings(".item").find(".iconfont:last");

	this.node.find('.item').find(".iconfont:last").removeClass(this.options.show).addClass(this.options.hide);
	if(itemContent.css("display") == "none"){
		this.node.find('.item-content').hide(300);
		toggles.removeClass(this.options.hide).addClass(this.options.show);
		itemContent.slideDown();
	}else{
		itemContent.slideUp();
		toggles.removeClass(this.options.show).addClass(this.options.hide);
	}
}
class TabSwitch{
    constructor(ele){
        this.index = 0;
        this.$ele = $(ele);

        this.$titleList = this.$ele.find('.tab-title-list');
        this.$titleItem = this.$titleList.children();
        this.$contentList = this.$ele.find('.tab-content-list');
        this.$contentItem = this.$contentList.children();
        let that = this;

        this.$titleItem.on('click',function () {
            let $this = $(this);
            let index = $this.index();
            if(index === that.getCurrentTabIndex()){
                return false;
            }
            that.updateTitleClass($this);
            that.updateShowTab(index);
            that.setActiveIndex(index);
        });
    }

    updateTitleClass($this){
        this.$titleItem.removeClass('active');
        $this.addClass('active');
    }

    getCurrentTabIndex(){
        return this.$ele.data('active-index') || 0;
    }

    updateShowTab(index){
        this.$contentItem.addClass('hidden').eq(index).removeClass('hidden');
    }

    setActiveIndex(index){
        this.$ele.data('active-index',index);
    }
}
;(function($){
	//图片验证与发送手机验证码
	var Verification = function (form,settings) {
		var _this = this;
		this.wait = 60;
		this.form = form;
		this.config = settings;
		// settings必须包含img和url
		if(!settings.img || !settings.url){
			console.error('请检查配置参数是否正确。');
		}
		form.find('.validate-img').bind('click',function(){
			_this.loadImg(form,_this);
		})
		form.find('.refresh').bind('click',function(){
			_this.loadImg(form,_this);
		})
		form.find('.send_code,#send_code').bind('click',function(e){
			console.log(_this.sendCode)
			_this.sendCode(form,e,_this);
		})
	}
	Verification.prototype = {
		time: function (o,self) {
			var _this=this;
			if (self.wait == 0) {
				o.html("发送验证码");
				self.wait = 60;
				o.attr('disabled', false);
			} else {
				o.html(self.wait + " s");
				self.wait--;
				setTimeout(function() {
					_this.time(o,self)
				},
				1000)
			}
		},
		loadImg: function (form,self) {
			var img = form.find('.validate-img > img').attr('src', `${self.config.img}?t=${(new Date().getTime())}`)
				.load(function() {
					if (!this.complete || typeof this.naturalWidth == "undefined" || this.naturalWidth == 0) {
						alert('验证码图片加载出错，请刷新');
					} else {
						form.find('.validate-img').html('').append(img);
					}
				});
			return false;
		},
		sendCode: function (form,e,self) {
			var _this=this;
			var code = form.find('input[name="verify"]').val();//验证码
            	e.preventDefault();
                if(self.wait != 60){
                    return;
                }
                var btn_o = form.find('a#send_code');
				var mobile = form.find('input[name=mobile]').val();//手机号
                $.ajax({
                    url: self.config.url + "?mobile=" + mobile + '&code=' + code,
                    beforeSend: function() {
                        btn_o.html('加载中');
                        btn_o.attr('disabled', true);
                        return true;
                    },
                    success: function(data) {
                        //成功状态，下面的是服务器返回的，数据库操作的状态
                        if(data.status == 1){
                            _this.time(btn_o,self);
                        }
                        else{
                            btn_o.html('获取验证码');
                            btn_o.attr('disabled', false);
							self.loadImg(form,self);
                        }
                        $.msgBox({
                            title: "提示",
                            content: data.info,
                            type: "info",
                        });
                    },
                    error: function(XMLHttpRequest, textStatus, errorThrown) {
                    	$.msgBox({
                            title: "错误",
                            content: $(XMLHttpRequest.responseText).find('h1').text(),
                            type: "error",
                        });
                        btn_o.html('获取验证码');
                        btn_o.attr('disabled', false);
						self.loadImg(form,self);
                    },
                });
		}
	}

	// 注册成jq方法
	$.fn.extend({
		verification: function (obj) {
			this.each(function(){
				new Verification($(this),obj);
			});
			return this;
		}
	})
	window.Verification = Verification;
})(jQuery);

class AjaxPage{
    constructor(el, option = {}){
        this.$el = $(el);
        this.$pageEl = this.$el.find('a');
        this.initPage = this.$el.find('.number.on').text().trim();
        this.totalPage = this.$el.data('total-page');
        this.page = this.initPage;
        this.url = '';
        this.lockStatus = false;

        this.$ajaxPageBox = this.$el.prev();
        this.domIndex = this.$el.index('.ajax-page');

        this.$parent = this.$el.parent();

        let defOpt = {
            activePageClass: 'current',
        };

        this.option = Object.assign({}, defOpt, option);

        this.init();
    }

    init(){
        let that = this;

        this.initDom();
    
        this.$el.find('input[name=page]').on('keyup', function (e) {
            if(e.keyCode === 13){
                that.$el.find('a.confirm').trigger('click');
            }
        });

        this.$pageEl.on('click', function (e) {
            e.preventDefault();
            if(that.isLock()){
                return false;
            }
            that.lock();

            let $this = $(this);

            let newPage = that.getPage($this);
            if(!newPage){
                return false;
            }

            that.$parent.addClass('ajax-page-loading__active');
            $this.siblings().removeClass(that.option.activePageClass);
            $this.addClass(that.option.activePageClass);

            that.url = that.getUrl(newPage);

            $("html,body").animate({
                scrollTop: that.$parent.offset().top - 150
            }, 300);

            that.getData().then((res)=> {

                let $newDomPage = $(res).find('.ajax-page').eq(that.domIndex);

                that.$ajaxPageBox.empty()
                    .html($newDomPage.prev().children());
                that.$parent.removeClass('ajax-page-loading__active');

                let newId = `ajax-page-${parseInt(new Date().getTime() * Math.random() * Math.random())}`;
                $newDomPage.attr('id', newId);
                that.$el.replaceWith($newDomPage);
                new AjaxPage(`#${newId}`, that.option);

                that.unLock();
            });
        });

    }

    updatePage(){

    }

    initDom(){
        if(this.$parent.hasClass('ajax-page-loading')){
            return false;
        }
        this.$parent.addClass('ajax-page-loading')
            .append(`
            <i class="icon ajax-page-loading-icon"></i>
            <div class="loading-mask"></div>
        `);
    }

    isLock(){
        return this.lockStatus;
    }

    lock(){
        this.lockStatus = true;
        return true;
    }

    unLock(){
        this.lockStatus = false;
    }

    getPage($el){
        let opera = $el.data('opera');
        let page = this.page;
        switch (opera) {
            case 'prev':
                --page;
                break;
            case 'pages':
                page = $el.text().trim();
                break;
            case 'next':
                ++page;
                break;
            case 'custom':
                page = $el.prevAll('input[name=page]').val();
                break;
            default:
                page = 1;
        }
        page = Math.max(1, page);
        page = Math.min(this.totalPage, page);

        this.page = page;
        return page;
    }

    getData(){
        return $.ajax({
            url: this.url,
        }).success((res)=>{
            return res;
        });
    }

    getUrl(page){
        var search = window.location.search;
        var url=window.location.href;
        if (search.indexOf('?')===-1){
            search='?page='+page;
            url+=search;
        }else if (search.indexOf('page=')===-1){
            url+='&page='+page;
        }else{
            url=url.replace(/page=\d+/,'page='+page);
        }
        return url;
    };
}



function goToLink(param, url = window.location.href.split('?')[0]){
    let name = param.name,
        val = param.val,
        urlParams = utils.getUrlParams(),
        paramsStr = '';
    if(val){
        if(!url.includes('?')){
            url += '?';
        }


        //把原来的参数拼回去
        for(let i in urlParams){
            if(i !== name){
                paramsStr += `${i}=${urlParams[i]}`;
            }
        }
        url += paramsStr;

        if(url[url.length - 1] !== '&' && url[url.length - 1] !== '?'){
            url += '&';
        }
        url += `${name}=${val}`;
        window.location.href = url;
    }
}

function showViewerImg(el) {
    $(el).each(function () {
        new Viewer(this,{
            url:function (image) {
                var dataSrc = $(image).data('src');
                var src = image.src;
                return dataSrc || src;
            },
            button: true,
            toolbar:{
                zoomIn:{
                    show:1,
                    size:'large'
                },
                zoomOut:{
                    show:1,
                    size:'large'
                },
                reset:{
                    show:1,
                    size:'large'
                },
                prev:{
                    show:1,
                    size:'large'
                },
                next:{
                    show:1,
                    size:'large'
                },
                rotateLeft:{
                    show:1,
                    size:'large'
                },
                rotateRight:{
                    show:1,
                    size:'large'
                },
            },
            title: false
        });
    });
}

$(function(){


    $(document).on('click','.tips-link',function(e){
        e.preventDefault();
        var target = $(this).data('target');
        $('.mask,.modal-box#'+target).fadeIn(100);
    });

    $('.modal-box .close').click(function (e) {
        e.preventDefault();
        $(this).parents('.modal-box').fadeOut(100);
        $('.mask').fadeOut(100);
    });

    new TabSwitch('.tab-pannel');
    $('.select-go-to-link').on('change',function () {
        let $this = $(this),
            name = $this.attr('name'),
            val = $this.val();
        goToLink({name: name,val: val});
    });
    
    
    $(function () {
        showViewerImg('.img-viewer');
        $(document).ajaxComplete(function(event,request,settings){
            showViewerImg('.img-viewer');
        });
    })
    
    $('.ajax-page').each(function () {
        new AjaxPage(this);
    });
});

